<div class="card-container" [ngStyle]="{ width: width ? width : '', height: height ? height : '' }">
  <div class="card-header">
    <ng-content select="[card-header]"></ng-content>
  </div>
  <div *ngIf="type === 'frame'" class="divider"></div>
  <ng-container *ngIf="type === 'frame'">
    <div class="card-body">
      <ng-content select="[card-body]"></ng-content>
    </div>
  </ng-container>
</div>
